
import { Routes, Route } from "react-router-dom";
import { 
  Profile, 
  Index, 
  Event, 
  About, 
  Customizations, 
  MyTickets,
  LazyWrapper 
} from "@/components/lazy/LazyRoutes";
import AuthenticationCheck from "./AuthenticationCheck";
import AdminRoutes from "./AdminRoutes";
import { User } from "@supabase/supabase-js";
import { logger } from "@/utils/logger";

interface ProtectedRoutesProps {
  user: User | null;
}

const ProtectedRoutes = ({ user }: ProtectedRoutesProps) => {
  logger.debug('Rendering ProtectedRoutes');
  
  return (
    <AuthenticationCheck>
      <Routes>
        <Route path="/" element={<LazyWrapper><Index /></LazyWrapper>} />
        <Route path="/profile" element={<LazyWrapper><Profile /></LazyWrapper>} />
        <Route path="/my-tickets" element={<LazyWrapper><MyTickets /></LazyWrapper>} />
        <Route path="/event/:id" element={<LazyWrapper><Event /></LazyWrapper>} />
        <Route path="/about" element={<LazyWrapper><About /></LazyWrapper>} />
        <Route path="/customizations" element={<LazyWrapper><Customizations /></LazyWrapper>} />
        <Route path="/admin/*" element={<AdminRoutes user={user} />} />
      </Routes>
    </AuthenticationCheck>
  );
};

export default ProtectedRoutes;
